var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"publication-page"}},[_c('div',{staticClass:"nav-space"}),_c('h1',[_vm._v("LAM, Man Ho (Donald) 林文昊")]),_c('h2',[_vm._v("mhlam@link.cuhk.edu.hk")]),_c('PublicationList'),_c('PreprintList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }